
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class EnquiryProductsGrid extends Serenity.EntityGrid<EnquiryProductsRow, any> {
        protected getColumnsKey() { return EnquiryProductsColumns.columnsKey; }
        protected getDialogType() { return EnquiryProductsDialog; }
        protected getIdProperty() { return EnquiryProductsRow.idProperty; }
        protected getInsertPermission() { return EnquiryProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return EnquiryProductsRow.localTextPrefix; }
        protected getService() { return EnquiryProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}